import { AfterViewInit, Component, effect, inject, OnChanges } from '@angular/core';
import { SnackbarService, SnackbarType } from '@shared/services/snackbar.service';

@Component({
  selector: 'app-snackbar',
  imports: [],
  templateUrl: './snackbar.component.html',
  styleUrl: './snackbar.component.scss',
})
export class SnackbarComponent {
  public open?: boolean;
  public serviceOpen?: boolean;
  public snackbarService = inject(SnackbarService);

  public constructor() {
    effect(() => {
      this.serviceOpen = this.snackbarService.snackbarData().open;
      if (this.serviceOpen) {
        setTimeout(() => {
          this.open = true;
        }, 5);
        setTimeout(() => {
          this.snackbarService.hideSnackbar();
        }, 5000);
      } else {
        setTimeout(() => {
          this.open = false;
        }, 300);
      }
    });
  }

  public get getIconFromType() {
    switch (this.snackbarService.snackbarData().variant) {
      case SnackbarType.success:
        return 'tick-circle';
      case SnackbarType.warning:
      case SnackbarType.info:
        return 'info-circle';
      case SnackbarType.error:
        return 'danger';
    }
  }
}
